import CryptoJS from 'crypto-js';
import UrlConfig from '../data/UrlConfig';
import Common from '../common/Common';

const SECRET_PASSPHRASE = process.env.REACT_APP_LOG_SECRET_PASSPHRASE; // <-- CHANGE THIS
const LOG_ENDPOINT = UrlConfig.log_track;

const SECRET_KEY = CryptoJS.SHA256(SECRET_PASSPHRASE);

const encryptLogData = (data) => {
  const jsonString = JSON.stringify(data);
  const iv = CryptoJS.lib.WordArray.random(16);

  const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  const combinedHex = iv.toString() + encrypted.ciphertext.toString();
  return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Hex.parse(combinedHex));
};

export const sendCodedLog = async (initialLogData) => {
  try {
    const logDataToSend = { ...initialLogData };

    logDataToSend.sessionId = sessionStorage.getItem('track_session_id');

    logDataToSend.userName = logDataToSend.guestName 
      || (initialLogData.user && initialLogData.user.username) 
      || localStorage.getItem('track_user_name') 
      || sessionStorage.getItem('track_user_name');
    
    delete logDataToSend.guestName;

    logDataToSend.userEmail = logDataToSend.userEmail 
      || localStorage.getItem('track_user_email') 
      || sessionStorage.getItem('track_user_email');

    logDataToSend.trafficSource = logDataToSend.trafficSource 
      || sessionStorage.getItem('track_traffic_source');


    // Asignar el timestamp formateado a logServiceTimestamp
    logDataToSend.logServiceTimestamp = Common.getArgentinaTimeStamp();

    const response = await fetch(LOG_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(logDataToSend),
    });

    if (!response.ok) {
      console.error('Failed to send coded log. Server responded with:', response.status, response.statusText);
    }

    const result = await response.json();
    if (result.status === 'error') {
      console.error('Coded log API error:', result.message);
    } else {
    }
  } catch (error) {
    console.error('Error sending coded log:', error);
  }
};